import React, { useEffect, useState, useMemo } from "react"
import { Flex, Layout } from "antd"
import styles from "./Index.module.css"
import { Outlet, useLocation } from "react-router-dom"
import { NavigationPath } from "../ProHomeLayout/NavigationPath"
import { PageName } from "ui/PageName"
import { getSettingsMenuList } from "pagesV2/pro/Settings/ProSettings"
import { routes } from "router/routes"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import classNames from "classnames"

export const ProSettingsLayout = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { role } = useSelector((store) => store.user)
  const isStaffUser = role === "staff_user"
  const settingsMenuList = useMemo(() => getSettingsMenuList(isStaffUser), [isStaffUser])
  const [settingsItem, setSettingsItem] = useState()
  const pageTitle = settingsItem?.name || t("guide.navigation.settings")
  const isLoginSecurity = settingsItem?.name === "Login & Security"
  const navigateBackPath = settingsItem ? routes.proSettingsRootPath() : routes.proHomeRootPath()

  useEffect(() => {
    // If pathname matches /pro/home/settings/template-detail, set subpage to Template Detail
    if (location.pathname.includes("/template-details")) {
      setSettingsItem({ name: "Template Details" })
      return
    }
    const selectedSettingsItem = settingsMenuList.find((menu) => menu.path === location.pathname)
    setSettingsItem(selectedSettingsItem)
  }, [location.pathname, settingsMenuList])
  const showFullWidth =
    settingsItem?.id === "profile-information" ||
    settingsItem?.id === "custom-questions" ||
    location.pathname.startsWith("/pro/home/settings/template-detail")
  const showWideWidth = settingsItem?.name === "Login & Security"
  const contentWidthClass = settingsItem ? (showFullWidth ? " " : showWideWidth ? styles.hasWideMaxWidth : styles.hasMaxWidth) : undefined
  return (
    <Layout className={classNames(styles.layout, contentWidthClass)}>
      <Flex className={styles.header}>
        <NavigationPath subPages={settingsItem && [isLoginSecurity ? "Login & Security / Account Management" : settingsItem.name]} />
        {settingsItem && !isLoginSecurity && !location.pathname.startsWith("/pro/home/settings/template-detail") && (
          <PageName title={pageTitle} backPath={navigateBackPath} />
        )}
      </Flex>
      <Outlet />
    </Layout>
  )
}
